function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "BoxedCloseFilter");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "BoxedCloseFilter",
  stroke: "#3F3F3D"
}, React.createElement("path", {
  d: "M3.09,3.34 L7.86,8.11",
  id: "Shape"
}), React.createElement("path", {
  d: "M7.86,3.34 L3.09,8.11",
  id: "Shape"
}), React.createElement("polyline", {
  id: "Shape",
  points: "3.01 0.61 0.55 0.61 0.55 10.61 3.04 10.61"
}), React.createElement("polyline", {
  id: "Shape",
  points: "8.04 10.61 10.55 10.61 10.55 0.61 8.07 0.61"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    version: 1.1
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/BoxedCloseFilter.682fccf2.svg";
export { SvgComponent as ReactComponent };